<script>
import { mapActions, mapGetters } from 'vuex'
import FILTRO_EMPTY from '@/models/filtro'
import PermissaoHelper from '../../PermissaoHelper'
import statusProcesso from '@/utils/status'
const { setores } = require('@/utils/rr/setor').default

export default {

  async created () {
    this.getPermissoes()
    this.usuario = await this.getUsuario()
  },

  mixins: [
    PermissaoHelper
  ],

  data () {
    return {
      statusAguardandoAnalise: [
        statusProcesso.AGUARDANDO_ANALISE,
        statusProcesso.AGUARDANDO_ANALISE_CONSULTOR,
        statusProcesso.AGUARDANDO_CONSULTA_OUTORGA,
        statusProcesso.AGUARDANDO_CONSULTA_SNCR
      ],
      statusEmAnalise: [
        statusProcesso.EM_ANALISE,
        statusProcesso.EM_CONSULTA_OUTORGA,
        statusProcesso.EM_CONSULTA_SNCR
      ],
      statusAguardandoValidacao: [
        statusProcesso.AGUARDANDO_VALIDACAO_DOCUMENTOS
      ],
      statusEmRevisao: [],
      usuario: null
    }
  },

  methods: {
    ...mapActions({
      getProcessos: 'processo/getProcessos',
      getInformacoes: 'informacao/getInformacoes',
      getOrdensServicos: 'ordemServico/getOrdemServico',
      getSubProcessos: 'subProcesso/getProcessos',
      getProcessoByOrdemServico: 'ordemServico/getProcessoByOrdemServico',
      getPermissoes: 'auth/setPermissoes',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      tramitar: 'processo/tramitar'
    }),
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),
    async init (callback) {
      const data = await this.buscar()
      if (callback) data.content = callback(data.content)
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      this.setorSelecionado = this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.setor.codigo : null
    },
    async initInformacoes () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async initOrdemServico () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async initProcessosOrdemServico () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.processosSelecionados = data.processosSelecionados
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async initSubProcessos () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    selecionaProcesso (item) {
      item.selecionado = !item.selecionado
      this.setProcessoSelecionados({ processos: _.cloneDeep(this.items.filter(i => i.selecionado)) || [], map: true }) //eslint-disable-line
    },
    async pesquisar (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async filtroComColunasExibidas () {
      this.filtro = { ...this.filtro }
    },
    async pesquisarInformacoes (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async pesquisarOrdemServico (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements
    },
    executar (item) {
      this[item.acao](this, item)
    },
    async changePage (newPage) {
      this.filtro.pagina = newPage - 1
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async buscar () {
      switch (this.filtro.caixa) {
        case 'INFORMACAO_SOLICITADA':
          return this.getInformacoes({ dados: { ...this.filtro } })
        case 'ORDEM_SERVICO':
          return this.getOrdensServicos({ dados: { ...this.filtro } })
        case 'LISTAGEM_PROCESSO_ORDEM_SERVICO': {
          this.filtro.numeroOs = this.numero
          this.loading = true
          const processos = await this.getProcessoByOrdemServico({ dados: { ...this.filtro } })
          this.loading = false
          return processos
        }
        case 'CAIXA_ENTRADA_OS':
        case 'EM_ANALISE_OS':
          return this.getSubProcessos({ dados: { ...this.filtro } })
        default:
          return this.getProcessos({ dados: { ...this.filtro } })
      }
    },
    async clear (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async clearInformacoes (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    checkProcessosSelecionados () {
      if (this.filtro.caixa === 'LISTAGEM_PROCESSO_ORDEM_SERVICO') {
        this.processosSelecionados.forEach((processoSelecionado) => {
          this.items = this.items.map((item) => {
            if (processoSelecionado.id === item.id) {
              item.selecionado = true
              if (processoSelecionado.disabled) {
                item.disabled = true
              }
            }
            return item
          })
        })
      } else {
        this.items.forEach((processo) => {
          if (this.idsProcessos) {
            const idProcesso = this.idsProcessos.find(id => id === processo.id)
            if (idProcesso !== undefined) {
              processo.selecionado = true
            }
          }
        })
      }
    },
    async clearFiltroOrdemServico (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async refresh (item) {
      let data = null
      if (item) {
        item.pagina = 0
      }
      if (item && (item.caixa === 'CAIXA_ENTRADA_OS' || item.caixa === 'EM_ANALISE_OS')) {
        const dados = { ...this.filtro }
        data = await this.getSubProcessos({ dados })
      } else {
        data = item ? await this.getProcessos({ dados: item }) : await this.buscar()
      }
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async refreshInformacoes (item) {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async refreshOrdemServico (item) {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async executarTramitacao (processo) {
      await this.tramitar({ processo })
    },
    async executarTramitacaoImpressaoTitulo (processo) {
      await this.tramitar({ processo: processo.idProcesso })
    },
    isVincularAnalista (processo) {
      return this.usuario.perfilSelecionado ? (this.usuario.perfilSelecionado.codigo.includes('CHEFE') || this.usuario.perfilSelecionado.codigo.includes('DIRETOR') || this.usuario.perfilSelecionado.codigo.includes('GERENTE')) : false
    },
    isAnalistaOrAtendentePerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('ATENDENTE') || this.usuario.perfilSelecionado.codigo.includes('ANALISTA')
    },
    isCoordanadorPerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('COORDENADOR')
    },
    isChefeSetorPerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('CHEFE_SETOR')
    },
    isAnalistaOrAtendente (processo) {
      return processo.codigoPerfil.includes('ATENDENTE') || processo.codigoPerfil.includes('ANALISTA') || processo.codigoPerfil.includes('ADMINISTRATIVO') || processo.codigoPerfil.includes('ASSESSOR') || processo.codigoPerfil.includes('TECNICO') || processo.codigoPerfil.includes('CONSULTOR')
    },
    isResponsavelCoordenador (processo) {
      return processo.codigoPerfil.includes('COORDENADOR')
    },
    isResponsavelChefeSetor (processo) {
      return processo.codigoPerfil.includes('CHEFE_SETOR')
    },
    processoIsAguardandoAnalise (processo) {
      return this.statusAguardandoAnalise.includes(processo.codigoStatus)
    },
    showCancelarRetificacaoProcesssoTecnicoCampo (processo) {
      return processo.retificacao
    },
    processoIsEmAnalise (processo) {
      return this.statusEmAnalise.includes(processo.codigoStatus)
    },
    processoIsAguardandoTituloCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_TITULO
    },
    processoIsAguardandoEmissaoCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_CERTIDAO_AREA
    },
    processoIsAguardandoEmissaoTitulo (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_TITULO
    },
    processoIsAguardandoBoleto (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_BOLETO
    },
    processoIsBoletoVencido (processo) {
      return processo.codigoStatus === statusProcesso.BOLETO_VENCIDO
    },
    processoIsAguardandoPortaria (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PORTARIA
    },
    processoIsEmEmissaoPortaria (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_PORTARIA
    },
    processoIsAguardandoPagamento (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PAGAMENTO || processo.parcelasQuitadas
    },
    processoIsAguardandoAcusarEntraga (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_ENTREGA
    },
    isProcessoAcusandoPublicacao (processo) {
      if (processo.setor === 'NUTIT') {
        return processo.codigoStatus === statusProcesso.AGUARDANDO_PUBLICACAO
      }
      return processo.codigoStatus === statusProcesso.ENVIADO_PARA_PUBLICACAO
    },
    processoIsAguardandoValidacao (processo) {
      return this.statusAguardandoValidacao.includes(processo.codigoStatus)
    },
    processoIsAguardandoPublicacao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PUBLICACAO
    },
    processoIsAguardandoConferenciaTitulo (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CONFERENCIA_TITULO || processo.codigoStatus === statusProcesso.AGUARDANDO_VALIDACAO_TITULO
    },
    processoIsAguardandoConferenciaCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CONFERENCIA_CERTIDAO || processo.codigoStatus === statusProcesso.AGUARDANDO_VALIDACAO_CERTIDAO
    },
    processoIsEmEmissaoCertidao (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_CERTIDAO
    },
    processoIsEmEmissaoTitulo (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_TITULO
    },
    processoIsAguardandoAnaliseOs (processo) {
      return processo.statusOrdemServico === statusProcesso.AGUARDANDO_ANALISE
    },
    processoIsEmAnaliseOs (processo) {
      return processo.statusOrdemServico === statusProcesso.EM_ANALISE
    },
    isResponsavel (processo) {
      return processo.responsavel !== '--'
    },
    showTrocarResponsavel (processo) {
      if (this.processoIsAguardandoEmissaoCertidao(processo) || this.processoIsAguardandoEmissaoTitulo(processo)) {
        return false
      } else {
        return ((this.hasPermissao(this.$permissao.TROCAR_ATENDENTE) ||
        this.hasPermissao(this.$permissao.VINCULAR_TROCAR_ANALISTA)) &&
        processo.idUsuario !== null &&
        !this.showContinuarCalcularVtnRR(processo))
      }
    },
    showArquivarAssinatura (processo) {
      return false
    },
    showRetornarSetorAssinatura (processo) {
      return false
    },
    showValidarOficio (processo) {
      return false
    },
    showRevisarOficio (processo) {
      return false
    },
    showAnalisarProcesso (processo) {
      return (this.processoIsAguardandoAnalise(processo) && this.hasPermissao(this.$permissao.ANALISAR_PROCESSO) &&
        (processo.idUsuario === this.usuario.id || processo.idUsuario === null)) || (this.processoIsAguardandoAnaliseOs(processo))
    },
    showEmitirExtratoSentenca (processo) {
      return ((processo.setor === 'NUTIT' && processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_EXTRATO_SENTENCA))
    },
    showEmitirCertidaoArea (processo) {
      return (processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_CERTIDAO_AREA || processo.codigoStatus === statusProcesso.EM_EMISSAO_CERTIDAO_AREA)
    },
    showAnalisarProcessoSemTramite (processo) {
      return false
    },
    showVincularAnalista (processo) {
      return this.hasPermissao(this.$permissao.VINCULAR_TROCAR_ANALISTA) && !this.isResponsavel(processo) && this.isVincularAnalista(processo)
    },
    showVincularTrocarGerente (processo) {
      return this.hasPermissao(this.$permissao.VINCULAR_TROCAR_GERENTE) && this.isResponsavel(processo)
    },
    showAcusarPublicacao (processo) {
      return this.isProcessoAcusandoPublicacao(processo) && this.hasPermissao(this.$permissao.ACUSAR_PUBLICACAO)
    },
    showAcusarAssinatura (processo) {
      return this.hasPermissao(this.$permissao.ACUSAR_RECEBIMENTO)
    },
    showConfirmarEntrega (processo) {
      return this.hasPermissao(this.$permissao.CONFIRMAR_ENTREGA)
    },
    showAcusarEntrega (processo) {
      return this.processoIsAguardandoAcusarEntraga(processo) && this.hasPermissao(this.$permissao.ACUSAR_ENTREGA)
    },
    showRevisarBase (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_REVISAO_BASE &&
        this.hasPermissao(this.$permissao.ATUALIZAR_BASE) && processo.idUsuario === this.usuario.id
    },
    showAtualizarBase (processo) {
      return this.hasPermissao(this.$permissao.ATUALIZAR_BASE)
    },
    showValidarAtualizacaoBase (processo) {
      return this.hasPermissao(this.$permissao.ATUALIZAR_BASE)
    },
    showContinuarAtualizacaoBase (processo) {
      return false
    },
    showContinuarRevisaoBase (processo) {
      return false
    },
    showValidarBase (processo) {
      return false
    },
    showAnalisarFinalizado (processo) {
      return this.hasPermissao(this.$permissao.ANALISAR_FINALIZADO)
    },
    showPublicarPortaria (processo) {
      return this.processoIsAguardandoPublicacao(processo) && this.hasPermissao(this.$permissao.PUBLICAR_PORTARIA)
    },
    showPublicarTermoRetificacao (processo) {
      return false
    },
    showValidarProcesso (processo) {
      return this.processoIsAguardandoValidacao(processo) && this.hasPermissao(this.$permissao.VALIDAR_ANALISE)
    },
    showValidarPortaria (processo) {
      return this.hasPermissao(this.$permissao.VALIDAR_PORTARIA)
    },
    showVisualizarProcesso (processo) {
      return true
    },
    showEmitirPortaria (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_PORTARIA
    },
    showContinuarEmissaoPortaria (processo) {
      return this.processoIsEmEmissaoPortaria(processo) && this.hasPermissao(this.$permissao.CADASTRAR_PORTARIA) && processo.idUsuario === this.usuario.id
    },
    showEmitirDae (processo) {
      return (this.processoIsAguardandoBoleto(processo) || this.processoIsBoletoVencido(processo)) && this.hasPermissao(this.$permissao.EMITIR_BOLETO)
    },
    showEditarDae (processo) {
      return (this.processoIsAguardandoBoleto(processo) || this.processoIsBoletoVencido(processo)) && this.hasPermissao(this.$permissao.EMITIR_BOLETO)
    },
    showDae (processo) {
      return this.processoIsAguardandoPagamento(processo) && this.hasPermissao(this.$permissao.VIEW_DAES)
    },
    labelShowDae () {
      return 'Gerenciar DAE'
    },
    showEmitirTitulo (processo) {
      return this.processoIsAguardandoEmissaoTitulo(processo) && this.hasPermissao(this.$permissao.EMITIR_TITULO)
    },
    showEmitirCertidao (processo) {
      return false
    },
    showContinuarEmitirTitulo (processo) {
      return this.processoIsEmEmissaoTitulo(processo) && this.hasPermissao(this.$permissao.CONTINUAR_EMISSAO_TITULO) && processo.idUsuario === this.usuario.id && (this.usuario.perfilSelecionado.codigo.includes(processo.codigoPerfil) || processo.codigoPerfil === 'SISTEMA')
    },
    showContinuarCertidao (processo) {
      return this.processoIsEmEmissaoCertidao(processo) && this.hasPermissao(this.$permissao.CONTINUAR_EMISSAO_CERTIDAO) && processo.idUsuario === this.usuario.id && this.usuario.perfilSelecionado.codigo.includes(processo.codigoPerfil)
    },
    showCancelarDaeDesarquivamento (processo) {
      return false
    },
    showDesarquivarProcesso (processo) {
      return processo.codigoStatus.includes('ARQUIVADO') && this.hasPermissao(this.$permissao.DESARQUIVAR_PROCESSO)
    },
    showConferirTitulo (processo) {
      return this.processoIsAguardandoConferenciaTitulo(processo) && this.hasPermissao(this.$permissao.CONFERIR_TITULO)
    },
    showConferirCertidao (processo) {
      return this.processoIsAguardandoConferenciaCertidao(processo) && this.hasPermissao(this.$permissao.CONFERIR_CERTIDAO)
    },
    showAvocarProcesso (processo) {
      return false
    },
    showArquivarProcesso (processo) {
      return this.hasPermissao(this.$permissao.ARQUIVAR_PROCESSO)
    },
    showAtualizacaoBase (processo) {
      return false
    },
    showRevisarAnalise (processo) {
      return processo.codigoStatus === statusProcesso.EM_REVISAO
    },
    showRevisarPortaria (processo) {
      return false
    },
    showContinuarAnalise (processo) {
      if (processo.setor === 'NUTIT') {
        return !(processo.codigoStatus === statusProcesso.EM_EMISSAO_EXTRATO_SENTENCA || processo.codigoStatus === statusProcesso.EM_EMISSAO_TITULO)
      }
      if (processo.setor === 'ARQUIVO') return false
      return (this.hasPermissao(this.$permissao.ANALISAR_PROCESSO) && processo.idUsuario === this.usuario.id &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_CERTIDAO &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_TITULO &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_CERTIDAO_AREA) && !this.showContinuarCalcularVtnRR(processo)
    },
    showContinuarEmissaoExtratoSentenca (processo) {
      return ((processo.setor === 'NUTIT' && processo.codigoStatus === statusProcesso.EM_EMISSAO_EXTRATO_SENTENCA))
    },
    showContinuarConferenciaTitulo (processo) {
      return false
    },
    showContinuarAnaliseTecnico (processo) {
      return processo.codigoStatus === statusProcesso.EM_ANALISE
    },
    showContinuarEmissaoCertidaoArea (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_CERTIDAO_AREA
    },
    showResponderInformacoes (processo) {
      return processo.status.toUpperCase() === statusProcesso.PENDENTE
    },
    showRetificarProcessso (processo) {
      return this.hasPermissao(this.$permissao.RETIFICAR_PROCESSO)
    },
    showCancelarRetificacaoProcessso (processo) {
      return processo.retificacao
    },
    showVisualizarCertidao (processo) {
      return processo.tipoCodigo === 'CERTIDAO_TITULO'
    },
    showVisualizarTitulo (processo) {
      if (processo.setor === 'GAB') {
        return (processo.codigoStatus !== statusProcesso.AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA)
      }
      return (processo.tipoCodigo !== 'CERTIDAO_TITULO')
    },
    showVisualizarRetificacaoTitulo (processo) {
      return false
    },
    showImprimirRetificacaoTitulo (processo) {
      return false
    },
    showVisualizarExtratoSentenca (processo) {
      return ((processo.setor === 'GAB' && processo.codigoStatus === statusProcesso.AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA))
    },
    showVisualizarOficio (processo) {
      return false
    },
    showEdital (processo) {
      return this.hasPermissao(this.$permissao.CADASTRAR_EDITAL) && processo.tipoCodigo === 'PERMUTA'
    },
    showUploadGuiaTransferencia (processo) {
      return false
    },
    //! Não encontrado
    showUploadTermoResgate (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    //! Não encontrado
    showUploadContrato (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    showUploadRecebimento (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    showGerarCustas (processo) {
      return this.hasPermissao(this.$permissao.GERAR_CUSTA) && processo.codigoStatus === statusProcesso.AGUARDANDO_CALCULO_CUSTAS
    },
    showAssinarTitulo (processo) {
      return this.hasPermissao(this.$permissao.ASSINAR_TITULO)
    },
    showEditarOs (processo) {
      return this.hasPermissao(this.$permissao.VIEW_ORDEM_SERVICO)
    },
    showDownloadOs (processo) {
      return this.hasPermissao(this.$permissao.VIEW_ORDEM_SERVICO)
    },
    showRetornarSetor (processo) {
      return (setores[this.usuario.perfilSelecionado.setor.codigo] &&
      (processo.codigoStatus !== statusProcesso.AGUARDANDO_CALCULO_VTN && processo.codigoStatus !== statusProcesso.EM_CALCULO_VTN)) &&
      !this.showContinuarCalcularVtnRR(processo)
    },
    showSolicitarRetificacao (processo) {
      return this.hasPermissao(this.$permissao.SOLICITAR_RETIFICACAO) && (
        this.usuario.perfilSelecionado.setor.codigo === setores.GPA ||
        this.usuario.perfilSelecionado.setor.codigo === setores.CAF ||
        this.usuario.perfilSelecionado.setor.codigo === setores.GCQ) && !processo.retificacao
    },
    showToltip (processo, codigo) {
      return !((processo.retificacao || (!processo.podeAnalisar && codigo !== statusProcesso.VALIDAR)) && (codigo === statusProcesso.ANALISAR_PROCESSO || codigo === statusProcesso.CONTINUAR_ANALISE || codigo === statusProcesso.VALIDAR))
    },
    textToltip (processo) {
      return processo.retificacao ? 'Processo em retificação' : (!processo.podeAnalisar ? 'Você não tem permissão para analisar esse processo' : '')
    },
    showVisualizarInformacoes (item) {
      return item.status.toUpperCase() === 'RESPONDIDA'
    },
    showColunaDias () {
      return false
    },
    isTramitarPublicacaoPortaria (item) {
      return false
    },
    isTramitarAtualizarBase (processo) {
      return false
    },
    showRevisarValidacaoProcesso () {
      return false
    },
    showCadastrarDadosCustas (processo) {
      return false
    },
    processoCadastrandoDadosCustas () {
      return false
    },
    processoIsEmPublicacao (processo) {
      return processo.codigoStatus === statusProcesso.EM_PUBLICACAO_PORTARIA
    },
    showContinuarPublicarPortaria (processo) {
      return this.processoIsEmPublicacao(processo) && this.hasPermissao(this.$permissao.PUBLICAR_PORTARIA)
    },
    showEmitirOficio (processo) {
      return false
    },
    showContinuarEmissaoOficio (processo) {
      return false
    },
    showCalcularVtnAp (processo) {
      return false
    },
    showCalcularVtnMa (processo) {
      return false
    },
    showContinuarCalcularVtnMa (processo) {
      return false
    },
    showRevisarVtn (processo) {
      return false
    },
    showContinuarCalcularVtnRR (processo) {
      return processo.codigoStatus === statusProcesso.EM_CALCULO_VTN
    },
    processoIsAguardandoCalculaVtn (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CALCULO_VTN
    },
    showCalcularVtnRr (processo) {
      return this.processoIsAguardandoCalculaVtn(processo)
    },
    showContinuarCalcularVtnAp (processo) {
      return false
    },
    showAguardandoDecisao (processo) {
      return false
    },
    showEmDecisao (processo) {
      return false
    },
    showAcusarDisponibilidade (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_DISPONIBILIDADE_TITULO
    },
    showIniciarValidacaoManual (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_VALIDACAO_DOCUMENTOS || processo.codigoStatus === statusProcesso.AGUARDANDO_DOCUMENTOS_INTERESSADO
    },
    showImprimirTitulo (processo) {
      return false
    },
    showRetornarArquivarImpressao (processo) {
      return false
    },
    showRetornarSetorImpressao (processo) {
      return false
    },
    showRegerarAnaliseAutomatizada (processo) {
      return processo.status !== 'PENDENTE'
    },
    showStatusAnaliseAutomatizada (processo) {
      return processo.jobId && processo.status !== 'MANUAL' && processo.status !== 'PENDENTE'
    },
    showSolicitarRetificacaoTitulo (processo) {
      return false
    },
    showCancelarTitulo (processo) {
      return false
    },
    showRetificarTituloCaixaEntrada (processo) {
      return false
    },
    showRetificarTituloCaixaAnalise (processo) {
      return false
    },
    showAcusarEntregaUsuario (processo) {
      const user = this.getUsuario()
      return processo.responsavel === user.pessoa.nomeRazaoSocial || processo.responsavel === '--'
    },
    showAcusarEntregaTitulo (processo) {
      return false
    },
    showAcaoSuspender (processo) {
      return false
    },
    showAcaoCancelarSuspensao (processo) {
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/listagem/ba/BaseFiltro.vue